import { useQuery } from '@tanstack/react-query';
import { fetchPathwayScormApprovals } from '../../../api/pathwayScormApprovals';
import { notifyError } from '../../../utils/notify';

export const PATHWAY_SCORM_APPROVALS_KEY = ['pathwayScormApprovals'];

const useGetPathwayScormApprovalsQuery = () =>
  useQuery(
    PATHWAY_SCORM_APPROVALS_KEY,
    async () => {
      const { data } = await fetchPathwayScormApprovals();
      return Array.isArray(data) ? data : [];
    },
    {
      retry: false,
      onError: e => {
        notifyError(e, false, 'Error fetching SCORM approval requests');
      },
    }
  );

export default useGetPathwayScormApprovalsQuery;
